/* eslint-disable @typescript-eslint/naming-convention */
import { inject, Injectable } from '@angular/core';
import { resolveOAuthClientId } from '@app/auth-client.resolver';
import { environment } from '@env/environment';
import { OFFICE_HOST_TYPE } from '@shared/tokens';
import { OtiService } from '@sp/oti-snippet';

import { AccountService } from './account.service';
import { AuthService } from './auth.service';
import { SettingsService } from './settings.service';

@Injectable({ providedIn: 'root' })
export class PendoService {
  private otiService: OtiService | undefined;
  private readonly officeHost = inject<Office.HostType | null>(OFFICE_HOST_TYPE);
  private readonly baseUrl: string;

  constructor(
    private authService: AuthService,
    private accountService: AccountService,
    private settingsService: SettingsService
  ) {
    this.baseUrl = this.settingsService.getParsedBaseUrl();
  }

  initialize(): void {
    if (!this.authService.hasValidToken()) {
      this.otiService = undefined;
      return;
    }
    const token = this.authService.accessToken;
    if (token == null || this.otiService) return; // skip if already initialized

    this.otiService = new OtiService();
    this.otiService.initialize({
      app_id: resolveOAuthClientId(this.officeHost),
      ot_key: environment.pendo.otKey,
      pendo_key: environment.pendo.key,
      pendo_url: environment.pendo.cname.content + '/agent/static/' + environment.pendo.key + '/pendo.js',
      pendo_visitor_url: `${this.baseUrl}api/json/pendo/visitor`,
      pendo_dnp_url: `${this.baseUrl}api/json/pendo/dnp`,
      pendo_metadata_url: `${this.baseUrl}api/json/pendo/meta`,
      prod_domain: 'firsttofile.com',
      pendo_cname_content: environment.pendo.cname.content,
      pendo_cname_data: environment.pendo.cname.data,
      pendo_details: {
        visitor: { id: this.accountService.userName },
        account: {
          id: this.accountService.accountDetails.clientName,
          accountName: this.accountService.accountDetails.clientName,
        },
      },
      request_headers: { Authorization: `Bearer ${token}` },
      pendo_visitor_payload: [],
      ot_localStorage: true,
    });
  }

  openCookiePreferences(): void {
    this.otiService?.openCookiePreferences();
  }
}
